/**
 * 自定义指令
 */
export default {
    inserted(el, bindings) {
        // console.log("自定义指令绑定", bindings.value, el.parentNode);
        //用setTimeOut保证在dom元素创建之后执行,否则会报错
        setTimeout(() => {
            if (!judgeAuthority(bindings.value)) {
                // 没有权限  移除组件
                if (el.parentNode != null)
                    el.parentNode.removeChild(el)
            }
        }, 100);
    },
    update(el, bindings) {
        // console.log("自定义指令绑定", bindings.value, el.parentNode);
        //用setTimeOut保证在dom元素创建之后执行,否则会报错
        setTimeout(() => {
            if (!judgeAuthority(bindings.value)) {
                // 没有权限  移除组件
                if (el.parentNode != null)
                    el.parentNode.removeChild(el)
            }
        }, 100);
    }
}

/**
 * 判断当前模块的对应操作的权限
 * @param {*} bindingValue 自定义指令绑定的值 {model:"" ,key:""}
 */
function judgeAuthority(bindingValue) {
    let AuthorityList = JSON.parse(localStorage.getItem(bindingValue.model)) // 系统设置的当前模块权限
    if (AuthorityList != null) {
        return AuthorityList.includes(bindingValue.key)
    } else {
        return false
    }
}